import { render, staticRenderFns } from "./EventsCard.vue?vue&type=template&id=8f1a0d06&"
import script from "./EventsCard.vue?vue&type=script&lang=js&"
export * from "./EventsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports